import { render } from "./Particle.vue?vue&type=template&id=455fbf54"
import script from "./Particle.vue?vue&type=script&lang=ts"
export * from "./Particle.vue?vue&type=script&lang=ts"

import "./Particle.vue?vue&type=style&index=0&id=455fbf54&lang=scss"
script.render = render

export default script